export default __webpack_public_path__ + "static/media/check.cc0f148c.svg";